import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-admin';
import { FullNameField } from '../../components/fields';

const Title = ({ translate, record = {} }) => (
    <span>
        { translate('resources.members.name', { smart_count: 1}) }: <FullNameField record={ record } />
    </span>
);

Title.propTypes = {
    translate: PropTypes.func,
    record: PropTypes.object,
};

export default translate(Title);